/**
 * AuthRoutes contains all unauthenticated/member-auth paths (login, signup,
 * magic link, checkout, payment status). Used by AuthGate when no user exists.
 */
import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FallbackSpinner from '../../components/FallbackSpinner';
import { CartProvider } from '../../contexts/CartContext';
import {
  MemberCheckout,
  MemberLogin,
  MemberProgramSignup,
  OldLoginPage,
  MagicLinkLogin,
  RequestMagicLink,
  MemberPaymentStatus,
  ThriveEarlyCheckout,
  ThriveEarlySignup,
  ThriveCheckPublicPage,
} from './lazyPages';

export const AuthRoutes = () => (
  <Suspense fallback={<FallbackSpinner />}>
    <CartProvider>
      <Routes>
        <Route path="/member/login" element={<MemberLogin />} />
        <Route path="/member/signup" element={<MemberProgramSignup variant="all" />} />
        <Route
          path="/member/signup/foundation"
          element={<MemberProgramSignup variant="foundation" />}
        />
        <Route path="/member/signup/core" element={<MemberProgramSignup variant="core" />} />
        <Route path="/oldlogin" element={<OldLoginPage />} />
        <Route path="/auth/magic-link" element={<MagicLinkLogin />} />
        <Route path="/auth/magic-login" element={<MagicLinkLogin />} />
        <Route path="/member/request-magic-link" element={<RequestMagicLink />} />
        <Route path="/member/checkout" element={<MemberCheckout />} />
        <Route path="/member/checkout/thrive-early" element={<ThriveEarlyCheckout />} />
        <Route path="/member/signup/thrive-early" element={<ThriveEarlySignup />} />
        <Route path="/member/payment-status" element={<MemberPaymentStatus />} />
        <Route path="/thrive-check-public" element={<ThriveCheckPublicPage />} />
        <Route path="*" element={<Navigate to="/member/login" replace />} />
      </Routes>
    </CartProvider>
  </Suspense>
);
